module.exports = __webpack_public_path__ + "static/media/logo-white.c0f85aff.png";